import { HomeStates } from './HomeStates';
import { NavigationStates } from './NavigationStates';
import { ToolStates } from './ToolStates';
import { ToolCategoryState } from './ToolCategoryState';
export const Contexts = () => {
    return {
        home_state: HomeStates(),
        tool_state: ToolStates(),
        tool_category_state: ToolCategoryState(),
        navigation_state: NavigationStates(),
    }
}